const backendAddress = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://localhost:4000/data" : "/data"
export default backendAddress 